import { Module } from '../Module';
import { WindowLocationService } from '../../commonInfra/services/WindowLocationService';

// Launches desktop applications using custom URI schemes (e.g. "tableau:" and "tableau-online-sync:")
export class DesktopApplicationLaunchService {

  // How long we wait to loose focus before declaring failure.
  // The window will lose focus instantly if the browser shows a security confirmation dialog.
  // Otherwise, the window will loose focus when the desktop app we are launching takes focus away from the browser.
  private static LaunchTimeoutMillis = 4000;

  private hiddenIFrame: HTMLIFrameElement;
  private $window: ng.IWindowService;

  public static $inject = [
    '$q',
    '$timeout',
    '$window',
  ];

  public constructor(private $q: ng.IQService,
                     private $timeout: ng.ITimeoutService,
                     $window: ng.IWindowService) {

    this.initHiddenIFrame($window);
    this.$window = $window;
  }

  private initHiddenIFrame($window: ng.IWindowService) {
    this.hiddenIFrame = $window.document.createElement('iframe');
    this.hiddenIFrame.className = 'ng-hide';
    $window.document.body.appendChild(this.hiddenIFrame);
  }

  // Open Tableau Desktop with a protocol handler
  public launchTableauDesktop(): ng.IPromise<any> {
    return this.launchDesktopApplication('tableau:', true);
  }

  // Open Online Sync Client with a protocol handler.
  // Note that this application launches in the background and does not take the focus,
  // so we have limited ability to know if this failed to launch anything.
  public launchSyncClientAndAssignToDatasource(siteUrlName: string,
                                               datasourceUrlName: string): ng.IPromise<any> {
    const uri = 'tableau-online-sync:///' + (siteUrlName || 'default') +
      '/claimScheduleForDatasource/' + datasourceUrlName;

    return this.launchDesktopApplication(uri, false);
  }

  private launchDesktopApplication(uri: string, onblurFailureDetection: boolean): ng.IPromise<any> {

    const blurDeferred: ng.IDeferred<any> = this.$q.defer();

    if (onblurFailureDetection) {
      $(this.$window).one('blur', () => {
        // Focus was blurred! Assume success since something opened to take focus away.
        blurDeferred.resolve(); // report success
      });

      // Fail after not getting blur event for a while
      this.$timeout(
        () => blurDeferred.reject(), // report failure
        DesktopApplicationLaunchService.LaunchTimeoutMillis
      );
    }

    try {
      WindowLocationService.navigateIFrameTo(this.hiddenIFrame, uri);
    } catch (e) {
      // Fail fast.
      // We were lucky enough to get an exception for the failure!
      // (Currently only Firefox will throw an exception here when the protocol is not recognized)
      return this.$q.reject();
    }

    if (!onblurFailureDetection) {
      // report success right away
      return this.$q.when();
    }

    // Wait for focus to blur or not...
    return blurDeferred.promise;
  }

}

Module.instance().service('DesktopApplicationLaunchService', DesktopApplicationLaunchService);
